import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    GetLeadFullResponse,
    GetLeadsParams,
    GetLeadsResponse,
    GetPreferencesParams,
    GetPreferencesResponse,
    GetSourcesResponse,
    GetThemesResponse,
    PreferencesDownloadExcelResponse,
    CreateDealPayload
} from '../types/preferences.types'

export class PreferencesRepository {
    getList(params: GetPreferencesParams): Promise<AxiosResponse<GetPreferencesResponse>> {
        return http.get('/crm/api/preferences', { params })
    }

    getLeadsList(params: GetLeadsParams): Promise<AxiosResponse<GetLeadsResponse>> {
        return http.get('/crm/api/deals', { params })
    }

    getThemes(): Promise<AxiosResponse<GetThemesResponse>> {
        const params = { page: 1, limit: 9999 }
        return http.get('/crm/api/preference/themes', { params })
    }

    getSources(): Promise<AxiosResponse<GetSourcesResponse>> {
        const params = { page: 1, limit: 9999 }
        return http.get('/crm/api/preference/sources', { params })
    }

    exportExcel(
        params: GetPreferencesParams
    ): Promise<AxiosResponse<PreferencesDownloadExcelResponse>> {
        return http.get('/crm/api/preferences/export', {
            responseType: 'blob',
            params: { ...params },
        })
    }

    exportLeadsExcel(
        params: GetLeadsParams
    ): Promise<AxiosResponse<PreferencesDownloadExcelResponse>> {
        return http.get('/crm/api/deals/export', {
            responseType: 'blob',
            params: { ...params },
        })
    }

    getLead(id: number): Promise<AxiosResponse<GetLeadFullResponse>> {
        return http.get(`/crm/api/deals/${id}`, { params: { id } })
    }

    createDeal(payload: CreateDealPayload): Promise<AxiosResponse<void>> {
        return http.post('/crm/api/deals', payload)
    }
}
